module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dawn-primary-nav-wrapper"
  }, [_c('div', {
    staticClass: "dawn-primary-nav"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _c('span', {
    staticClass: "dawn-primary-nav-toggle",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]), _c('ul', {
    staticClass: "primary-nav-menu",
    class: [_vm.menuClosed ? _vm.hideMenu : !_vm.menuClosed, _vm.showMenu]
  }, _vm._l((_vm.items), function(item, index) {
    return (item.permissions) ? _c('li', {
      key: index,
      staticClass: "primary-nav-item-wrapper"
    }, [_c('router-link', {
      staticClass: "primary-nav-item",
      attrs: {
        "to": {
          path: item.path
        },
        "tag": "span",
        "active-class": "active"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))])]), (_vm.subNav) ? _c('div', {
    staticClass: "dawn-seconday-nav"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "secondary-nav-menu"
  }, _vm._l((_vm.subNav), function(item, index) {
    return _c('li', {
      staticClass: "secondary-nav-item-wrapper"
    }, [_vm._v(":key='index'"), _c('router-link', {
      staticClass: "secondary-nav-item",
      attrs: {
        "to": {
          path: item.path
        },
        "tag": "span",
        "active-class": "active"
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("images/../logo.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-255d6c76","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edPrimaryNav/index.vue
// module id = 3c9l
// module chunks = 13 14